export const Texts = {
    LOADING_CONTENT_DESCRIPTION: 'Cargando...',
    FAILED_DURING_LOAD_WHATSAPP_COMPONENT: 'No se pudo cargar el componente de WhatsApp',
    SELECT_CONTACT_TEXT: 'Seleccione un contacto para ver una conversación'
}
